import { useDispatch } from 'react-redux';
import { postProductData } from '../../Redux/actions';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { MdVerified } from 'react-icons/md';
import ImageZoomHover from '../image/ImageZoom';
const SliderCarts = ({ item, name, img, desc, price, mrp, discount, stockQuantity, productType, bestSeller = null }) => {



  const dispatch = useDispatch()
 
  const addToCart = (product) => {
    dispatch(postProductData(product
    ));
    // setIsCartOpen(true)  
    toast.success("Product Added Successfully!!")

  };
  function calculateDiscount(mrp, price) {
    if (mrp <= 0 || price > mrp) return "Invalid values";
    const discount = ((mrp - price) / mrp) * 100;
    return Math.floor(discount)+ "%" +" off";
  }
  // className='mt-5 mx-auto w-[150px]   sm:w-[200px] sm:h-[450px] md:w-[350px] md:h-[550px] lg:w-[300px] lg:h-[480px] xl:w-[300px] xl:h-[480px] flex flex-col hover:scale-105 ease-in-out duration-200 border-2 border-black'
  return (
    <div className=".font-Inter relative    flex flex-col  justify-between mx-0 p-1 sm:p-2 bg-gray-50 ">
      <Link to={`/products/${item.shortUrl}`} state={{ data: item, productType: productType }} className=''>
      <ImageZoomHover
        src={img}
        className={" aspect-square"}      />
        {/* <LazyImage src={img} alt={name} className={" aspect-square"} style={{ filter: "brightness(95%)" }} /> */}
      </Link>
            <Link to={`/products/${item.shortUrl}`} state={{ data: item, productType: productType }} className=''>

      <div className="flex flex-col items-start p-[10px] md:p-[20px] md:pb-0">
        <div className='flex  gap-2 mb-[12px]'>
          <div className='bg-[#33873c] flex gap-1 items-center h-[19px] w-[55px] justify-center text-white'>
            <span className='text-white h-[12px] w-[12px]' ><svg
              fill='currentColor'
              clipRule="evenodd"
              fillRule="evenodd"
              strokeLinejoin="round"
              strokeMiterlimit={2}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m11.322 2.923c.126-.259.39-.423.678-.423.289 0 .552.164.678.423.974 1.998 2.65 5.44 2.65 5.44s3.811.524 6.022.829c.403.055.65.396.65.747 0 .19-.072.383-.231.536-1.61 1.538-4.382 4.191-4.382 4.191s.677 3.767 1.069 5.952c.083.462-.275.882-.742.882-.122 0-.244-.029-.355-.089-1.968-1.048-5.359-2.851-5.359-2.851s-3.391 1.803-5.359 2.851c-.111.06-.234.089-.356.089-.465 0-.825-.421-.741-.882.393-2.185 1.07-5.952 1.07-5.952s-2.773-2.653-4.382-4.191c-.16-.153-.232-.346-.232-.535 0-.352.249-.694.651-.748 2.211-.305 6.021-.829 6.021-.829s1.677-3.442 2.65-5.44z"
                fillRule="nonzero"
              />
            </svg>
            </span>
            <span className='text-[12px]'><span className="">
            {item?.rating||0} </span></span>
          </div>
          <div className='border-2 border-[#cccc] flex gap-1 items-center h-[19px]  text-white px-1'>
            <MdVerified className='text-[#09afec] text-[13px] ' />
            <span className='text-[7px] sm:text-[9px] font-[400] text-black whitespace-nowrap'>{item?.ratingCount>100?"100+":item?.ratingCount||0} Reviews</span>

          </div>
        </div>


        <h2 className="text-[12px] text-black text-ellipsis line-clamp-1 font-[600] leading-[17px] text-start">{name}</h2>
        <h2 className="text-[11px] mt-[5px]  text-[#969696] text-ellipsis line-clamp-1 font-[600] leading-[17px] text-start">{item?.productbenefit}</h2>
        <div className='flex   justify-start items-center gap-x-2   my-2'>
          <p className='text-[14px] sm:text-[16px] font-semibold text-black '>₹{price}</p>
          <p className='text-[11px] line-through text-[#969696] font-semibold'>₹{mrp}</p>
          <p className='text-[12px] whitespace-nowrap overflow-hidden text-ellipsis  text-[#33873c] font-semibold'>( {calculateDiscount(mrp,price)} )</p>
        </div>
      </div>
      </Link>
      {
        stockQuantity === 0 ? (
          <button className='.font-Inter text-[12px] flex justify-center items-center text-white font-[600]    h-[41px] uppercase cursor-not-allowed bg-gray-700  duration-150 ease-in-out' >Out Of Stock</button>
        ) :
          <button
           className='font-Inter text-[12px] flex justify-center items-center bg-black text-white font-[600]  h-[41px] uppercase cursor-pointer   duration-150 ease-in-out ' 
          onClick={() => addToCart(item)}>Add to cart</button>
      }
      {bestSeller !== null && <div className='bg-black text-white absolute rounded-br-[10px]  font-[500]  left-2 top-2 flex items-center justify-center px-3  text-[11px] h-[24px] '>{bestSeller ? "Best Seller" : "New Arrival"}</div>
      }    </div>
  )
}

export default SliderCarts